// ============================================================
// Accessibility Fixes — Home Page - Start
// ============================================================

// ----------------------------------------------------------
// Fix 1: Empty links — Judge.me review popup cards
// Targets: a.jdgm-popup-card__full-rev-link
// ----------------------------------------------------------
function fixEmptyReviewPopupLinks() {
  document.querySelectorAll('a.jdgm-popup-card__full-rev-link').forEach(function (el) {
    if (!el.textContent.trim() && !el.getAttribute('aria-label')) {
      el.setAttribute('aria-label', 'Read full review');
    }
  });
}

// ----------------------------------------------------------
// Fix 2: Empty links — Judge.me "all reviews" product button
// Targets: a.jdgm-full-rev__product-button
// ----------------------------------------------------------
function fixEmptyAllReviewsLinks() {
  document.querySelectorAll('a.jdgm-full-rev__product-button').forEach(function (el) {
    if (!el.textContent.trim() && !el.getAttribute('aria-label')) {
      el.setAttribute('aria-label', 'Read all reviews for this product');
    }
  });
}

// ----------------------------------------------------------
// Run all fixes on DOM ready
// ----------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  fixEmptyReviewPopupLinks();
  fixEmptyAllReviewsLinks();
});

// ----------------------------------------------------------
// Re-run on dynamically injected content
// Judge.me renders widgets via JS after page load
// ----------------------------------------------------------
const a11yObserver = new MutationObserver(function () {
  fixEmptyReviewPopupLinks();
  fixEmptyAllReviewsLinks();
});

a11yObserver.observe(document.body, { childList: true, subtree: true });

// ============================================================
// Accessibility Fixes — Home Page -End
// ============================================================


// ============================================================
// Save At Airpuria Page — Accessibility Fixes
// ============================================================

document.addEventListener('DOMContentLoaded', function () {

  const labelMap = {
    'storeifyInput_first_name': 'First Name',
    'storeifyInput_last_name': 'Last Name',
    'storeifyInput_3676acb3adfe': 'Field',
    'storeifyInput_d4821a16f159': 'Field',
    'storeifyInput_c8b515d88e60': 'Comment',
    'storeify_form_attach_file': 'Attach File',
  };

  document.querySelectorAll(
    '.storeify-div-input input, .storeify-div-input textarea, input[id^="storeify_form_attach_file"]'
  ).forEach(function (el) {
    // Skip if already labelled
    if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return;

    const baseName = el.id.replace(/_\d+$/, '');
    const labelText = labelMap[baseName] || el.placeholder || el.name || 'Field';

    el.setAttribute('aria-label', labelText);
  });

});

/* ── Cart: Bold app empty button — add aria-label ── */
(function () {
  function fixBoldButtons() {
    document.querySelectorAll('.bold_cart_edit_button').forEach(function (btn) {
      if (!btn.getAttribute('aria-label') && !btn.textContent.trim()) {
        btn.setAttribute('aria-label', 'Edit cart item');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBoldButtons);
  } else {
    fixBoldButtons();
  }

  var observer = new MutationObserver(fixBoldButtons);
  observer.observe(document.body, { childList: true, subtree: true });
})();


